<template>
  <div class="page-enhance">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2">Enhance My Listing</h1>
  </div>
</template>

<script>
export default {
  name: 'EnhanceListing',
};
</script>
